// Module
var code = `{{svgGlobeAlt}}
<p class="text-[44px]">{{logoText}}</p>
`;
// Exports
module.exports = code;